// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import axios from 'axios'
import BaiduMap from 'vue-baidu-map';
import "@/utils/rem";
import "animate.css";
import LocalCache from "@/utils/cache";
import '@/assets/style/element-ui.scss'
import store from '@/store';
import MDialog from "@/components/dialog/index.vue";

Vue.component("MDialog", MDialog);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.$LocalCache = LocalCache;

// 设置Vue全局实例，用于在其他模块中访问Vue原型方法
window.Vue = Vue;

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "oWdCGOihdSKNgn6x7OiQqhQAeBOOLyAS"
});

//  引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 注册public公共js start
import Public from './utils/public'
Vue.prototype.Public = Public;
// 注册public公共js end

// import { Button, Select } from 'element-ui';
// Vue.use(Button)
// Vue.use(Select)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
// axios.defaults.withCredentials = true


// WEBPACK FOOTER //
// ./src/main.js